import React from 'react';
import { motion } from 'framer-motion';

/**
 * ObliqueSwitch - Animated toggle switch control.
 */
export function Switch({
    checked = false,
    onChange,
    label,
    disabled = false,
    className = '',
    ...props
}) {
    return (
        <label className={`inline-flex items-center gap-3 cursor-pointer select-none ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
            <div
                onClick={() => !disabled && onChange && onChange(!checked)}
                className={`
                    relative w-11 h-6 rounded-full transition-colors duration-200 p-0.5
                    ${checked ? 'bg-[var(--accent,#6366f1)]' : 'bg-[var(--border)]'}
                `}
                {...props}
            >
                <motion.div
                    className="w-5 h-5 rounded-full bg-white shadow-xs"
                    animate={{ x: checked ? 20 : 0 }}
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                />
            </div>
            {label && (
                <span className="text-[13px] font-medium text-[var(--text-primary)]">
                    {label}
                </span>
            )}
        </label>
    );
}
